import { createSlice } from "@reduxjs/toolkit";
import { NewsletterResponseDto } from "../../shared/dtos/newsletter/NewsletterResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const newsletterSlice = createSlice({
  name: "newsletter",
  initialState: getInitialCrudState<NewsletterResponseDto>(),
  reducers: {
    ...generateCrudReducers<NewsletterResponseDto>(),
  },
});

export const newsletterActions = newsletterSlice.actions;
export default newsletterSlice.reducer;
